import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserInfo = React.lazy(() =>
    import('../UserInfo')
);
const userInfoRoutesRegistry = [
    {
        path: PAGE_URL.USER_INFO_PAGE,
        element: <UserInfo />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userInfoRoutesRegistry;
